import { styled } from '@mui/material/styles';

export const ImagesBody = styled('div')({
    border: '1px solid #ddd',
    borderTop: 'none'
});

export const ImageGrid = styled('div')(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, 260px)',
    justifyContent: 'center',
    gap: '36px',
    padding: '16px',
    [theme.breakpoints.down('sm')]: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '16px',
        padding: '8px'
    }
}));
